<kendo-popup [anchor]="anchor.element" (anchorViewportLeave)="show = false" *ngIf="show">
    <div class="content" [ngStyle]="{'width': Width, 'height': Height}">
        <ng-content></ng-content>
    </div>
</kendo-popup>
<div class="example-config">
    <kendo-button #anchor (click)="onToggle()">
        <ng-content select=".anchor"></ng-content>
    </kendo-button>
</div>